rwgps.ns("postcards", function() {
  // public namespace
  var ns = this;

  // image position and scale is serialized independent of postcard resolution. do not change, serialized layouts expect this value.
  // res ind. px values scaled up by this factor
  var noResPxNormFactor = 2 << 11;
  // res ind. scale factors scaled up by this factor
  var noResScaleNormFactor = 2 << 16;

  var defaultAspectRatio = 3;

  // filmstrip mode shows 3 photos in the metrics flippers, so we require at least 3 photos to enable it
  var minImagesForFilmstrip = 3;

  // private classes
  var ImageScaler, ImageMover;

  // structure of objects in postcard.images
  var ImageProto = {
    img: null, // the dom img element
    origWidth: 0, // full res src dimension
    origHeight: 0,
    ratio: 0.0, // (w/h), used in autoconfiguring layout (placeImages)
    src: '',
    scale: 0.0, // orig dimensions * scale = display dimensions
    marginLeft: 0.0, // relative to containing cell
    marginTop: 0.0
  };

  var defaultOptions = {
    cellSpacing: 1
  };

  ns.Postcard = function(postcardSel, options) {
    this.$postcard = $(postcardSel);
    this.$container = $('.imagecells', this.$postcard);
    this.containerWidth = this.$container.width();
    this.containerHeight = this.$container.height();
    this.options = _.extend(options || {}, defaultOptions);

    this.cells = []; // will contain all .cell elements
    this.images = []; // will contain image specs
    this.filmstripEnabled = false; // will get enabled once postcard is initialized with enough images

    if(this.options.srcs || this.options.layout) {
      this.init();
    }
  }

  // event support for postcard instances
  _.extend(ns.Postcard.prototype, Backbone.Events);
  // and at the class level to apply to all postcards
  _.extend(ns.Postcard, Backbone.Events);

  var layouts = ns.Postcard.layouts = {
    1: {
    },
    2: {
      row: [{}, {width: 1.5}]
    },
    3: {
      row: [{width: 1.5},{stack:[{},{}]}]
    },
    "3a": {
      stack: [{},{row:[{},{}]}]
    },
    4: {
      row: [
        {stack:[{height: 2},{}]}, {stack:[{},{height: 2}]}]
    },
    "4a": {
      stack: [{row: [{},{}]}, {row: [{},{}]}]
    },
    "4b": {
      row: [
        {},
        {stack: [{}, {row: [{},{}]}]}
      ]
    },
    "4c": {
      stack: [
        {}, {row: [{},{},{}]}
      ]
    },
    5: {
      row: [
        {stack:[{},{}]},
        {},
        {stack:[{},{}]}]
    },
    "5b": {
      row: [
        {width: 2},
        {
          width: 3,
          stack: [
            {row: [{width:1}, {width:2}]},
            {row: [{width:2}, {width:1}]}
          ]
        }
      ]
    },
    6: {
      row: [
        {
          width: 2,
          stack: [
            {height: 2},
            {height: 1}
          ]
        },
        {
          width: 4,
          stack: [
            {height: 1},
            {
              height: 2,
              row: [
                {width: 2},
                {
                  width: 2,
                  stack: [
                    {height: 1},
                    {height: 1}
                  ]}]}]}]
    },
    "6a": {
      stack: [
        {row: [{},{},{}]},
        {row: [{},{},{}]}
      ]
    },
    "6b": {
      row: [
        {stack: [{height:2},{height:1}]},
        {stack: [
          {row: [{},{}]},
          {row: [{},{}]}
        ]}
      ]
    },
    "gt6": {
      row: [
        {
          width: 2,
          stack: [
            {height: 2},
            {height: 1}
          ]
        },
        {
          width: 4,
          stack: [
            {height: 1},
            {
              height: 2,
              row: [
                {width: 2},
                {
                  width: 2,
                  stack: [
                    {height: 1},
                    {height: 1,
                      row: [{},{}]
                    }
                  ]}]}]}]

    },
    8: {
      row: [
        {
          width: 2,
          stack: [
            {height: 2},
            {height: 1}
          ]
        },
        {
          width: 3,
          stack: [
            {height: 1},
            {
              height: 2,
              row: [
                {width: 2},
                {
                  width: 2,
                  stack: [
                    {height: 1},
                    {height: 1,
                      row: [{},{}]
                    }
                  ]}]}]
        },
        {
          width: 1
        }]}
  };

  ns.Postcard.prototype.init = function(layoutKey) {
    var layout;
    // can init with a populated layout, or with a layout key & srcs, or just srcs
    if(this.options.layout) {
      layout = this.processLayout(this.options.layout);
    } else if(!layoutKey && this.options.srcs) {
      layoutKey = this.options.srcs.length > 6 ? "gt6" : this.options.srcs.length;
    }
    this.renderLayout(layout || layoutKey);
    this.cells = $('.cell', this.$container).toArray();
    this.images = [];
    if(this.options.layout) {
      this.loadImagesFromLayout();
    } else if(this.options.srcs) {
      this.loadImagesFromSrcs();
    }

    this.filmstripEnabled = !this.options.disableFilmstrip && !this.options.edit && this.images.length >= minImagesForFilmstrip;
    if(this.filmstripEnabled) {
      this.$postcard.addClass("filmstrip-enabled").addClass('clickable-images');
      this.initFilmstrip();
    }
    if(this.options.clickableImages) {
      this.initClickableImages();
      this.$postcard.addClass("clickable-images");
    }
    if(this.options.edit) this.$postcard.addClass("edit-enabled");
    if(this.options.fluid) this.initFluid();
    this.initExpandoOverview();
  }

  ns.Postcard.prototype.enableFluid = function() {
    var $pcWrapper = this.$container.closest('.ambassador-route-postcard');
    if($pcWrapper.size() > 0 && !this.options.fluid) {
      $pcWrapper.addClass('fluid');
      this.options.fluid = true;
      this.initFluid();
      this.fluidResize();
    }
  };

  ns.Postcard.prototype.disableFluid = function() {
    var $pcWrapper = this.$container.closest('.ambassador-route-postcard');
    if($pcWrapper.size() > 0 && this.options.fluid) {
      $pcWrapper.removeClass('fluid');
      this.options.fluid = false;
      var w = $pcWrapper.width(),
        h = Math.round(w / defaultAspectRatio);
      this.$container.height(h);
      if($pcWrapper.hasClass('with_ambassador')) {
        $pcWrapper.find('.inner-container').width(w);
        // this is the width of the ambassador logo & name, including 10px of margin.
        w -= 140;
      }
      this.$container.width(w);
      this.renderIfSizeChanged();
    }
  };

  ns.Postcard.prototype.initExpandoOverview = function() {
    var $wrapper = this.$container.closest('.ambassador-route-postcard');

    $wrapper.find('.route-overview a').on('click', function() {
      var $footer = $(this).closest('.footer');
      $footer.find('.route-overview').hide();
      $footer.find('.full-overview').show();
      return false;
    });
    $wrapper.find('.full-overview a').on('click', function() {
      var $footer = $(this).closest('.footer');
      $footer.find('.full-overview').hide();
      $footer.find('.route-overview').show();
      return false;
    });
  }

  ns.Postcard.prototype.initFluid = function() {
    // only init once
    if(this._fluidResizeEnabled) return;
    this._fluidResizeEnabled = true;

    var pc = this;

    var syncResizeOnFirstThenDebounce = (function() {
      var delayResize = 0, debounceTime = 300;
      return function() {
        if(!delayResize) {
          pc.fluidResize(); // do one resize immediately.
          delayResize = -1; // but don't do another immediate resize
          setTimeout(function() { delayResize = 0; }, debounceTime); // but reset that soon
        } else {
          // resize called again within our debounce time, so let's debounce it for real.
          if(delayResize > 0) {
            clearTimeout(delayResize); // we use -1 as our special val, otherwise it's a real timeout we need to clear
          }
          delayResize = setTimeout(function() { delayResize = 0; pc.fluidResize(); }, debounceTime); // actually resize and reset!
        }
      }
    }());

    $(window).resize(syncResizeOnFirstThenDebounce);
    // if the window resize even isn't thrown (for example find#index on map expansion), can trigger this event to resize all postcards on page
    ns.Postcard.on('resize', syncResizeOnFirstThenDebounce);
    this.fluidResize();
  }

  ns.Postcard.prototype.fluidResize = function() {
    if(this.$container.length == 0) return;
    if(!this.options.fluid) return;

    var $fluid = this.$container.closest('.fluid'),
      fullW = $fluid.width(),
      w = fullW,
      h = this.options.fixedHeight || Math.round(w / defaultAspectRatio);
    if($fluid.hasClass('with_ambassador')) {
      // this is the width of the ambassador logo & name, including 10px of margin.
      w -= 140;
    }
    $fluid.find('.inner-container').width(fullW);
    this.$container.width(w).height(h);
    this.renderIfSizeChanged();
  }

  ns.Postcard.prototype.renderIfSizeChanged = function() {
    var newW = this.$container.width(),
      newH = this.$container.height();
    if(newW != this.containerWidth || newH != this.containerHeight) {
      this.containerWidth = newW;
      this.containerHeight = newH;
      this.init();
    }
  }

  // let user click on images and just fire an event that can be listened to
  ns.Postcard.prototype.initClickableImages = function() {
    var pc = this;
    $('.flip-container', this.$container).on('click', function() {
      var image = pc.images[$(this).find(".cell").attr('data-imageI')];
      pc.trigger('image:click', image);
    });
  }

  // set up filmstrip-mode, which let's a user click on a photo to see it larger, and nav through all photos
  ns.Postcard.prototype.initFilmstrip = function() {
    var pc = this;
    // make it a circular doubly linked list for our filmstrip
    for(var i=0; i < this.images.length; i++) {
      if(i === 0)
        this.images[i].prev = this.images[this.images.length-1];
      else
        this.images[i].prev = this.images[i-1];
      if(i === this.images.length-1)
        this.images[i].next = this.images[0];
      else
        this.images[i].next = this.images[i+1];
    }
    $('.flip-container', this.$container).on('click', function() {
      if($(this).find(".metric-flipper").size() > 0 || !pc.filmstripEnabled) return;

      pc.createSupercell();

      var image = pc.images[$(this).find(".cell").attr('data-imageI')];
      pc.showImageInSupercell(image);
    });

    this.$postcard.on("click", '.metric-flipper .back', function() {
      var topPos = $(this).closest(".metric-flipper").position().top;
      if(topPos === 200) {
        pc.showImageInSupercell("next");
      } else if(topPos === 0) {
        pc.showImageInSupercell("prev");
      }
    });

    this.$container.on('click', '.supercell', function() {
      pc.showImageInSupercell("next");
    });

    this.$container.on('click', '.closesupercell', function() {
      pc.$container.find('.supercell').remove();
      $(this).remove();
      _.each(pc.images, function(x) { pc.fillCell(x.cell, x, true); });
      pc.flipMetrics(true);
    });

    $(".flip-container .front.cell", this.$container).on("mouseenter", function() {
      $(this).closest(".flip-container").css({zIndex: 3});
    }).on("mouseleave", function() {
      $(this).closest(".flip-container").css({zIndex: 2});
    });
  }

  // load only images necessary and render layout exactly as specified in layout spec
  ns.Postcard.prototype.loadImagesFromLayout = function() {
    var pc = this;
    this._imagesToPlace = 0;
    _.each(this.cells, function(cell) {
      // layout specified image spec, expecting scale, margins, src
      var imageOpts = $(cell).data('cell').imageOpts;
      if(!imageOpts) return;

      pc.placingImage();
      var x = _.extend({}, ImageProto, imageOpts);
      x.img = new Image;
      x.img.src = x.src;
      // if image no longer exists, handle gracefully  (so at least the postcard editor can be used)
      x.img.onerror = function() {
        pc.placedImage(cell);
      };
      x.img.onload = (function(x) { return function() {
        x.origWidth = x.img.width;
        x.origHeight = x.img.height;
        x.ratio = x.origWidth / x.origHeight;
        pc.images.push(x);
        setTimeout((function(cell) { return function() {
          pc.fillCell(cell, x, true, false, "crossfade");
          pc.placedImage();
        }})(cell), Math.random() * 200);
      };})(x);
    }, this);
  }

  // load all images specified in srcs and autoconfigure layout
  ns.Postcard.prototype.loadImagesFromSrcs = function() {
    var pc = this;
    var toLoad = 0;
    for(var i=0; i < this.options.srcs.length; i++) {
      toLoad++;

      var x = _.extend({}, ImageProto);
      x.img = new Image;
      x.img.src = x.src = this.options.srcs[i];
      x.img.onload = (function(x) { return function() {
        x.origWidth = x.img.width;
        x.origHeight = x.img.height;
        x.ratio = x.origWidth / x.origHeight;
        toLoad--;
        if(toLoad === 0) pc.placeImages();
      };})(x);
      this.images.push(x);
    }
  }

  // attempt to intelligently place images in the best cell, match images to cells by comparing aspect ratios
  // (panos get dibs on wide cells)
  ns.Postcard.prototype.placeImages = function() {
    var pc = this;
    this._imagesToPlace = 0;

    this.images.sort(function(a,b) {
      var r1 = a.ratio;
      var r2 = b.ratio;
      if(r1 > 1) r1 = 1/r1;
      if(r2 > 1) r2 = 1/r2;
      return r1-r2;
    });
    var cellsIdx = _.map(this.cells, function(cell) {
      var cw = $(cell).width();
      var ch = $(cell).height();
      var cratio = cw / ch;
      return {
        cell: cell,
        cw: cw,
        ch: ch,
        cratio: cratio
      };
    });
    _.each(this.images, function(x) {
      if(cellsIdx.length === 0) return;
      cellsIdx.sort(function(a,b) {
        var r1 = a.cratio;
        var r2 = b.cratio;
        return Math.abs(r2-x.ratio)-Math.abs(r1-x.ratio);
      });
      var cellx = cellsIdx.shift();
      x.cell = cellx.cell;
      this.placingImage();
      setTimeout((function(cell) { return function() {
        pc.fillCell(cell, x, true, false, "crossfade");
        pc.placedImage();
      }})(cellx.cell), Math.random() * 200);
    }, this);
  }

  // all the img tags are present on the page, images are loaded, the postcard is done initializing at this point
  ns.Postcard.prototype.onImagesPlaced = function() {
    if(this.options.edit) {
      this.setupEditingTools();
    }
    // invoke callback if provided
    if(this.options.onImagesPlaced) this.options.onImagesPlaced();
  }

  // handle the callback onImagesPlaced. need to track how many images we're waiting on (there is a random timeout)
  ns.Postcard.prototype.placedImage = function(errorCell) {
    if(errorCell) {
      if(!this.errorCells) this.errorCells = [];
      this.errorCells.push(errorCell);
    }
    this._imagesToPlace--;
    if(this._imagesToPlace === 0) {
      if(this.errorCells && this.errorCells.length > 0 && this.images.length > 0) {
        _.each(this.errorCells, function(cell) {
          // copy the first image and stick it in the error cell to get a non-broken postcard
          var image = _.extend({}, this.images[0]);
          image.img = image.img.cloneNode();
          this.images.push(image);
          this.fillCell($(cell), image, true, false, "crossfade");
        }, this);
      }
      this.onImagesPlaced();
    }
  }
  ns.Postcard.prototype.placingImage = function() {
    this._imagesToPlace++;
  }

  ns.Postcard.prototype.renderLayout = function(layoutOrKey) {
    if(_.isObject(layoutOrKey)) {
      this.layout = layoutOrKey;
    } else {
      // snag the layout from our layout templates
      this.layout = $.extend(true, {}, layouts[layoutOrKey]);
    }
    var cells = [];
    var spacing = this.options.cellSpacing;
    // walk nested, res-independent layout spec, and build list of actual size, absolutely positioned cells
    (function parseLayout(layout, opts) {
      // rows, stacks, and elements have lots in common, just require some translation.
      var list, fixedDim, scaledDim, fixedOffset, variableOffset;
      if(layout.row) {
        list = layout.row;
        fixedDim = "height";
        scaledDim = "width";
        fixedOffset = "top";
        variableOffset = "left";
      } else if(layout.stack) {
        list = layout.stack;
        fixedDim = "width";
        scaledDim = "height";
        fixedOffset = "left";
        variableOffset = "top";
      } else {
        // reached cell-level element
        opts = _.extend({}, opts);
        opts.width -= spacing;
        opts.height -= spacing;
        opts.layoutObj = layout;
        if(layout.image) {
          opts.imageOpts = layout.image;
        }
        cells.push(opts);
        return;
      }
      var totalAbsScaledDim = opts[scaledDim];
      var totalRelScaledDim = 0;
      _.each(list, function(x) {
        if(!x[scaledDim]) x[scaledDim] = 1;
        totalRelScaledDim += x[scaledDim];
      });
      var scalingFactor = totalAbsScaledDim / totalRelScaledDim;
      var variableOffsetCursor = opts[variableOffset];
      _.each(list, function(subLayout) {
        var cellOpts = {}
        cellOpts[variableOffset] = variableOffsetCursor;
        cellOpts[fixedOffset] = opts[fixedOffset];
        cellOpts[scaledDim] = Math.round(subLayout[scaledDim] * scalingFactor);
        cellOpts[fixedDim] = opts[fixedDim];
        parseLayout(subLayout, cellOpts);
        variableOffsetCursor += cellOpts[scaledDim];
      });
    })(this.layout, {top: 0, left: 0, width: this.containerWidth, height: this.containerHeight});

    // do a pass to fix rounding issues. this gets us perfect {spacing}px gaps separating images.
    // on an 8 img test layout this is only 112 iterations, so not using sorted data structure
    var ys=[], xs=[], eps=5;
    _.each(cells, function(cell) {
      var i;
      for(i=0;i<ys.length;i++) {
        if(Math.abs(cell.top - ys[i]) < eps) {
          cell.top = ys[i];
        }
        if(Math.abs(cell.top + cell.height + spacing - ys[i]) < eps) {
          cell.height = ys[i] - spacing - cell.top;
        }
      }
      for(i=0;i<xs.length;i++) {
        if(Math.abs(cell.left - xs[i]) < eps) {
          cell.left = xs[i];
        }
        if(Math.abs(cell.left + cell.width + spacing - xs[i]) < eps) {
          cell.width = xs[i] - spacing - cell.left;
        }
      }
      ys.push(cell.top);
      ys.push(cell.top + cell.height + spacing);
      xs.push(cell.left);
      xs.push(cell.left + cell.width + spacing);
    });

    // build the layout dom and style it up so everything is pixel perfect
    this.$container.empty();
    var pc = this;
    _.each(cells, function(cell) {
      var $cell = $("<div class='flip-container'><div class='flipper'><div class='front cell'></div><div class='back'></div></div></div>");
      $cell.css({
        position: 'absolute',
        width: cell.width,
        height: cell.height,
        top: cell.top,
        left: cell.left
      });
      $cell.find('.front,.back').css({
        width: cell.width,
        height: cell.height
      });
      $cell.find('.cell').data('cell', cell);
      pc.$container.append($cell);
    });
  }

  // walk through a serialized layout and convert resolution independent values to values normalized for current postcard res
  ns.Postcard.prototype.processLayout = function processLayout(serialized) {
    var layout = {};
    if(serialized.width) layout.width = serialized.width;
    if(serialized.height) layout.height = serialized.height;

    if(serialized.row)
      return _.extend(layout, {row: _.map(serialized.row, processLayout, this)});
    if(serialized.stack)
      return _.extend(layout, {stack: _.map(serialized.stack, processLayout, this)});
    if(serialized.image) {
      if(this.options.editedImageUrls && serialized.image.editedImageId) {
        layout.image = {
          photoId: serialized.image.photoId,
          src: this.options.editedImageUrls[serialized.image.editedImageId]
        };
      } else {
        layout.image = {
          photoId: serialized.image.photoId,
          src: serialized.image.src,
          scale: serialized.image.scaleNoRes * this.containerWidth / noResScaleNormFactor,
          marginLeft: serialized.image.marginLeftNoRes * this.containerWidth / noResPxNormFactor,
          marginTop: serialized.image.marginTopNoRes * this.containerHeight / noResPxNormFactor
        };
      }
    }
    return layout;
  }

  // serialize postcard layout with resolution independent values
  var serializingTruncationFactor = 1000; // plenty of precision while avoiding full precision doubles that save as strings
  ns.Postcard.prototype.serializeLayout = function(layout, photoIds) {
    var serialized = {};
    if(!layout) {
      photoIds = [];
      layout = this.layout;
      serialized.photoIds = photoIds;
    }
    if(layout.width) serialized.width = layout.width;
    if(layout.height) serialized.height = layout.height;

    if(layout.row)
      return _.extend(serialized, {row: _.map(layout.row, function(x) { return this.serializeLayout(x, photoIds) }, this)});
    if(layout.stack)
      return _.extend(serialized, {stack: _.map(layout.stack, function(x) { return this.serializeLayout(x, photoIds) }, this)});
    if(layout.image) {
      var photoId = parseInt(layout.image.src.match(/photos(?:\/\w+)?\/([0-9]+)/)[1]),
        $cell = $(layout.image.img).closest('.cell'),
        w = $cell.width(),
        h = $cell.height(),
        relW = this.containerWidth,
        relH = this.containerHeight;

      serialized.image = {
        src: layout.image.src,
        scaleNoRes: Math.floor(serializingTruncationFactor * noResScaleNormFactor * layout.image.scale / relW) / serializingTruncationFactor,
        marginLeftNoRes: Math.floor(serializingTruncationFactor * noResPxNormFactor * layout.image.marginLeft / relW) / serializingTruncationFactor,
        marginTopNoRes: Math.floor(serializingTruncationFactor * noResPxNormFactor * layout.image.marginTop / relH) / serializingTruncationFactor,
        widthNoRes: Math.floor(serializingTruncationFactor * noResPxNormFactor * w / relW) / serializingTruncationFactor,
        heightNoRes: Math.floor(serializingTruncationFactor * noResPxNormFactor * h / relH) / serializingTruncationFactor,
        photoId: photoId
      };
      photoIds.push(photoId);
    }
    return serialized;
  }

  // put an image into a cell.
  ns.Postcard.prototype.fillCell = function(cell, image, cropFill, clone, effect) {
    var imageChanged = false; // most the time we're filling the cell for the very first time.
    var $cell = $(cell);
    var cw = $cell.width();
    var ch = $cell.height();
    var cratio = cw / ch;
    var img;
    if(clone) {
      img = image.img.cloneNode();
    } else {
      $(image.img).remove();
      img = image.img;
    }
    $(img).addClass('postcard-cell-image');
    if(effect === "crossfade") {
      var $oldImg = $cell.find('img.postcard-cell-image').css({opacity: 0, position: 'absolute'}).removeClass('postcard-cell-image');
      setTimeout(function() { $oldImg.remove(); }, 600);
      var $newImg = $(img);
      $newImg.css({position: 'absolute', opacity: 0});
      $cell.prepend($newImg);
      setTimeout(function() {
        $newImg.css({opacity: 1});
      }, 0);
    } else {
      $cell.empty().append(img);
    }
    // maintain correctness of images list.
    var imageI = _.indexOf(this.images, image);
    if(imageI === -1) {
      // not in the array? this cell has been filled in the past, so replace its previous image in our images array
      imageI = $cell.attr('data-imageI');
      this.images[imageI] = image;
      imageChanged = true;
    }
    // update our dom-embedded ref back to the images list
    $cell.attr('data-imageI', _.indexOf(this.images, image));

    // figure out placement & size
    if(image.scale) {
      // layout spec provided us with a scale, use it.
      //
      // since we force the layout to round to whole pixels, and force a 1 px spacing between images, using the scale directly can
      // result in an image that isn't quite wide or tall enough to fill the cell - usually off by 1 or a couple pixels.
      //
      // note: in some cases where the image has the same (or nearly the same) aspect ratio as its cell, after adjusting for 1 dimension the
      // other dimension is still short. that's why the height test is another if, not if-else, after the width test.

      var newW = image.scale * image.origWidth,
        newH = image.scale * image.origHeight,
        adjScale;
      if(cw > newW) {
        adjScale = cw / newW;
        newW = cw;
        newH *= adjScale;
      }
      if(ch > newH) {
        adjScale = ch / newH;
        newH = ch;
        newW *= adjScale;
      }
      img.style.width = newW + 'px';
      img.style.height = newH + "px";
      img.style.marginLeft = (image.marginLeft + parseFloat(img.style.width) < cw ? cw - parseFloat(img.style.width) : image.marginLeft) + 'px'
      img.style.marginTop = (image.marginTop + parseFloat(img.style.height) < ch ? ch - parseFloat(img.style.height) : image.marginTop) + 'px'
    } else if(cropFill ? image.ratio > cratio : image.ratio < cratio) {
      // fit vertically, center horizontally
      newW = ch * image.ratio;
      img.style.width =  newW + "px";
      img.style.height = ch + "px";
      image.marginLeft = -((newW-cw)/2);
      image.marginTop = 0;
      img.style.marginLeft = image.marginLeft + 'px';
      img.style.marginTop = image.marginTop + 'px';
    } else {
      // fit horizontally, center vertically
      img.style.width = cw + "px";
      newH = 1/image.ratio * cw;
      img.style.height = newH + "px";
      image.marginTop = -((newH-ch)/2);
      image.marginLeft = 0;
      img.style.marginLeft = image.marginLeft + 'px';
      img.style.marginTop = image.marginTop + 'px';
    }

    // if we're editing we need to reset the image scaler for this replaced image
    if(imageChanged && this.options.edit) {
      for (var i = 0; i < this.imageScalers.length; i++) {
        if (this.imageScalers[i].$cell[0] === $cell[0]) {
          this.imageScalers[i].imageChanged();
          break;
        }
      }
    }
    var data = $cell.data('cell');
    if(data && data.layoutObj)
      data.layoutObj.image = image;
  }

  ns.Postcard.prototype.setupEditingTools = function() {
    var pc = this,
      $cells = this.$postcard.find('.cell');

    // set up image mover support.
    $cells.on('mousedown', 'img.postcard-cell-image', function(e) {
      if($(e.currentTarget).hasClass('postcard-cell-image')) {
        $(this).closest('.cell').find('.image-scaler').hide();
        pc.startMoveImage(e, $(this));
      }
    });

    // set up image scaler support.
    pc.imageScalers = [];
    $cells.each(function() {
      var $cell = $(this),
          scaler = new ImageScaler(pc, $cell);
      scaler.$el.hide();
      pc.imageScalers.push(scaler);
    });
    $cells.on('mouseover', function() {
      if(!pc.imageScaler && !pc.imageMover)
        $(this).find('.image-scaler').show();
    }).on('mouseout', function() {
      if(!pc.imageScaler && !pc.imageMover)
        $(this).find('.image-scaler').hide();
    });
  }

  // ImageMover <=> Postcard glue
  ns.Postcard.prototype.startMoveImage = function(e, $img) {
    this.imageMover = new ImageMover($img);
    this.imageMover.start(this, e);
  }
  ns.Postcard.prototype.imageMoveComplete = function() {
    var image = this.images[this.imageMover.$cell.attr('data-imageI')];
    image.marginLeft = this.imageMover.pxStrToFloat(this.imageMover.$img.css('marginLeft'));
    image.marginTop = this.imageMover.pxStrToFloat(this.imageMover.$img.css('marginTop'));
    if (this.options.onImageMoveComplete) {
      this.options.onImageMoveComplete()
    }
    delete this.imageMover;
  }


  // set up the main image view for filmstrip mode
  ns.Postcard.prototype.createSupercell = function() {
    var $cell = $('<div class="supercell"></div>');
    $cell.css({
      position: 'absolute',
      left: 0,
      top: 0,
      width: 599,
      height: 299,
      backgroundColor: '#333'
    });
    this.$container.append($cell);

    // and create abort button
    var $abort = $("<div class='closesupercell'><i class='icon-reply icon-3x'></i></div>");
    $abort.css({
      position: 'absolute',
      left: 10,
      top: this.containerHeight - 53,
      width: 42,
      height: 43,
      color: "#999",
      cursor: "pointer"
    });
    this.$container.append($abort);
  }

  // spin the metrics around when going in/out of filmstrip mode
  ns.Postcard.prototype.flipMetrics = function(reverse) {
    var seqDelay = 50;
    var toFlip = $('.metric-flipper', this.$postcard).closest('.flip-container').toArray();
    if(reverse) toFlip.reverse();
    (function flipNext() {
      if(toFlip.length === 0) return;
      var $nextFlip = $(toFlip.shift());
      $nextFlip[reverse ? 'removeClass' : 'addClass']("hover");
      $nextFlip.emulateTransitionEnd(400)
      $nextFlip.find(reverse ? ".front" : ".back").css({visibility: "visible"});
      $nextFlip.one(transitionEndEvent, function() {
        $(this).find(reverse ? ".back" : ".front").css({visibility: "hidden"});
      })
      setTimeout(flipNext, seqDelay);
    })();
  }

  // display an image in the main image view during filmstrip mode and update filmstrip cells
  ns.Postcard.prototype.showImageInSupercell = function(image) {
    if(image === "next" || image === "prev") {
      var copyIdx, addFn, topOffset, imagePtrName, rmIdx, topOffsetChange;
      if(image === "next") {
        copyIdx = 2;
        addFn = "after";
        topOffset = 300;
        imagePtrName = "next";
        rmIdx = 0;
        topOffsetChange = -100;
      } else {
        copyIdx = 0;
        addFn = "before";
        topOffset = -100;
        imagePtrName = "prev";
        rmIdx = 3;
        topOffsetChange = 100;
      }
      var pc = this;
      $(".metricscells", this.$postcard).queue(function() {
        var $metricscells = $(this);
        var stripTrio = $('.metric-flipper .back', $metricscells).toArray();
        // create offscreen thumb
        var anchorSlot = $(stripTrio[copyIdx]).closest('.flip-container').get(0);
        var newSlot = anchorSlot.cloneNode(true);
        $(newSlot).css({
          top: topOffset
        });
        $(anchorSlot)[addFn](newSlot);
        pc.fillCell($(newSlot).find('.back'), pc.images[$(stripTrio[copyIdx]).attr("data-imageI")][imagePtrName], true);

        // and animate it!
        var flippers = $(".metric-flipper", $metricscells).toArray();
        if(image === "prev") flippers.reverse();
        var lastFrontHtml;
        (function animatem() {
          if(flippers.length === 0) return;
          var $flipper = $(flippers.shift());
          $flipper.css({top: $flipper.position().top + topOffsetChange});
          var frontHtml = $flipper.find(".front").html();
          $flipper.find('.front').html(lastFrontHtml);
          lastFrontHtml = frontHtml;
          setTimeout(animatem, 15);
        })();
        setTimeout(function() {
          $($(".metric-flipper", $metricscells).get(rmIdx)).remove();
          $metricscells.dequeue();
        }, 430);
      });
      var $supercell = $(".supercell", this.$container);
      this.fillCell($supercell, this.images[$supercell.attr("data-imageI")][imagePtrName], false, true, "crossfade");
    } else {
      this.fillCell($(".supercell", this.$container), image, false, true, "crossfade");
      this.flipMetrics();
      var stripTrio = $('.metric-flipper .back', this.$postcard).toArray();
      this.fillCell(stripTrio[0], image.prev, true);
      this.fillCell(stripTrio[1], image, true);
      this.fillCell(stripTrio[2], image.next, true);
    }
  }

  // editor tool to let user adjust image scaling by dragging a slider
  // manages the scale property of image objects directly.
  ImageScaler = function(postcard, $cell) {
    this.postcard = postcard;
    this.$cell = $cell;

    this.currentSize = {width: 0, height: 0};

    this.buildSlider();
    this.imageChanged();
  }
  ImageScaler.prototype = {
    imageChanged: function() {
      // set up drag environment based on image in cell
      this.image = this.postcard.images[this.$cell.attr('data-imageI')];
      this.$img = $(this.image.img);
      this.image.scale = $(this.image.img).height() / this.image.origHeight;
      this.maxScale = 1;
      this.minScale = this.calcMinScale();
      this.scaleRange = this.maxScale - this.minScale;
      this.renderSliderKnobPosition();
    },
    buildSlider: function() {
      this.$el = $([
        '<div class="image-scaler">',
        '<div class="slider-bar">',
        '<div class="slider-knob">',
        '</div></div></div>'
      ].join(''));
      this.$sliderKnob = this.$el.find('.slider-knob');
      this.$cell.append(this.$el);
      this.$el.width(this.$cell.width() - 20)
        .css('top', this.$cell.height() - 20);

      var scaler = this;
      this.$el.find('.slider-bar').on('mousedown', function() {
        scaler.onBarClick.apply(scaler, arguments);
      });
    },
    calcMinScale: function() {
      var ch = this.$cell.height(),
        cw = this.$cell.width(),
        cratio = cw / ch;
      if(this.image.ratio > cratio) {
        return ch / this.image.origHeight;
      } else {
        return cw / this.image.origWidth;
      }
    },
    onBarClick: function(e) {
      this.setBoundedImageScale(e.pageX);
      this.startDrag(e);
      this.renderMove();
    },
    startDrag: function(e) {
      this.postcard.imageScaler = this;

      var centerX = this.$cell.width() / 2 + this.$cell.offset().left - this.$img.offset().left;
      var centerY = this.$cell.height() / 2 + this.$cell.offset().top - this.$img.offset().top;
      this.centerXPct = centerX / this.$img.width();
      this.centerYPct = centerY / this.$img.height();

      // cancel out any text selections
      document.body.focus();
      // prevent text selection in IE
      document.onselectstart = function () { return false; };
      // prevent stuff on the page from getting selected during drag
      e.preventDefault();

      var scaler = this;
      this.onMouseMove = function() {
        scaler.move.apply(scaler, arguments);
      };
      this.onMouseUp = function() {
        scaler.success();
      };
      $(window).on('mouseup', this.onMouseUp)
        .on('mousemove', this.onMouseMove);

      this.$img.addClass('notransition');
    },
    renderSliderKnobPosition: function() {
      var offset = -4;
      this.$sliderKnob.css('left', (this.image.scale - this.minScale) / this.scaleRange * this.$el.width() + offset);
    },
    setBoundedImageScale: function(mouseY) {
      var pct = (mouseY - this.$el.offset().left) / this.$el.width();
      if(pct < 0) pct = 0;
      else if(pct > 1) pct = 1;
      var mult = pct * this.scaleRange + this.minScale;
      this.image.scale = mult;
      this.currentSize.width = this.image.origWidth * mult;
      this.currentSize.height = this.image.origHeight * mult;
    },
    move: function(e) {
      // get bounded mouse position to prevent image from escaping frame
      this.setBoundedImageScale(e.pageX);

      var scaler = this;
      if(this._renderId) {
        cancelAnimationFrame(this._renderId);
      }
      this._renderId = requestAnimationFrame(function() { scaler.renderMove(); });
    },
    renderMove: function() {
      this.renderSliderKnobPosition();
      this.$img.width(this.currentSize.width);
      this.$img.height(this.currentSize.height);
      var left = -(this.centerXPct * this.currentSize.width - this.$cell.width()/2),
        top = -(this.centerYPct * this.currentSize.height - this.$cell.height()/2);

      // bound image to its frame
      var minLeft = this.$cell.width() - this.$img.width(),
        minTop = this.$cell.height() - this.$img.height();

      if(left > 0) left = 0;
      else if(left < minLeft) left = minLeft;
      if(top > 0) top = 0;
      else if(top < minTop) top = minTop;

      this.$img.css('marginLeft', left + 'px');
      this.$img.css('marginTop', top + 'px');
    },
    success: function() {
      if (this.postcard.options.onImageScaleComplete) {
        this.postcard.options.onImageScaleComplete()
      }
      this.cleanup();
    },
    cleanup: function() {
      // cancel any pending rendering
      if(this._renderId) {
        cancelAnimationFrame(this._renderId);
      }
      this._renderId = requestAnimationFrame(function() { scaler.renderMove(); });

      // undo our text selection prevention for IE
      document.onselectstart = null;

      $(window).off('mouseup', this.onMouseUp)
        .off('mousemove', this.onMouseMove);

      var scaler = this;
      _.defer(function() {
        scaler.$img.removeClass('notransition');
      });
      delete this.postcard.imageScaler;
    }
  }

  // editing tool - handles state of dragging an image around to reposition it inside a cell, or move to another cell.
  ImageMover = function($img) {
    this.$img = $img;
    this.$cell = $img.closest('.cell');
    this.imageOffset = $img.offset();
    this.cellOffset = $img.closest('.cell').offset();
    this.mouseToImage = {left: 0, top: 0};
    this.mouseToImageOffset = {left: 0, top: 0};
    this.mouseOffset = {left: 0, top: 0};
  }
  ImageMover.prototype = {
    pxStrToFloat: function(str) {
      return parseFloat(str.replace('px',''));
    },
    start: function(postcard, mousedownEvent) {
      this.postcard = postcard;

      // cancel out any text selections
      document.body.focus();
      // prevent text selection in IE
      document.onselectstart = function () { return false; };
      // prevent stuff on the page from getting selected during drag
      mousedownEvent.preventDefault();

      // set initial state
      this.mouseToImage.left = this.pxStrToFloat(this.$img.css('marginLeft')) - mousedownEvent.pageX;
      this.mouseToImage.top = this.pxStrToFloat(this.$img.css('marginTop')) - mousedownEvent.pageY;
      this.mouseToImageOffset.left = this.imageOffset.left - mousedownEvent.pageX;
      this.mouseToImageOffset.top = this.imageOffset.top - mousedownEvent.pageY;
      this.setBoundedMouseOffset(mousedownEvent.pageX, mousedownEvent.pageY);

      var mover = this;
      this.onMouseMove = function() {
        mover.move.apply(mover, arguments);
      };
      this.onMouseUp = function() {
        mover.success();
      };
      $(window).on('mouseup', this.onMouseUp)
        .on('mousemove', this.onMouseMove);

      // pop the image out of the postcard so it sits above everything
      $('body').prepend(this.$img.remove());
      this.$img.addClass('postcard-moving');
      this.$img.offset(this.imageOffset);
      // render frame to display cell bounds
      this.$frame = $('<div></div>').addClass('postcard-moving-frame');
      $('body').prepend(this.$frame)
      this.$frame.offset({left: this.cellOffset.left-1, top: this.cellOffset.top-1})
        .width(this.$cell.width())
        .height(this.$cell.height());
    },
    setUnboundedMouseOffset: function(mouseLeft, mouseTop) {
      this.mouseOffset.left = mouseLeft;
      this.mouseOffset.top = mouseTop;
    },
    setBoundedMouseOffset: function(mouseLeft, mouseTop) {
      var left = mouseLeft + this.mouseToImageOffset.left;
      var top = mouseTop + this.mouseToImageOffset.top;
      // bound image to its frame
      var minLeft = this.cellOffset.left + this.$cell.width() - this.$img.width(),
        minTop = this.cellOffset.top + this.$cell.height() - this.$img.height(),
        amountExceeding = 0;
      if(left > this.cellOffset.left) {
        amountExceeding = left - this.cellOffset.left;
        left = this.cellOffset.left;
      } else if(left < minLeft) {
        amountExceeding = minLeft - left;
        left = minLeft;
      }
      if(top > this.cellOffset.top) {
        amountExceeding = Math.max(amountExceeding, top - this.cellOffset.top);
        top = this.cellOffset.top;
      } else if(top < minTop) {
        amountExceeding = Math.max(amountExceeding, minTop - top);
        top = minTop;
      }

      mouseLeft = left - this.mouseToImageOffset.left;
      mouseTop = top - this.mouseToImageOffset.top;
      this.mouseOffset.left = mouseLeft;
      this.mouseOffset.top = mouseTop;
      return amountExceeding;
    },
    popOut: function() {
      this.poppedOut = true
      this.$frame.remove(); // remove the positioning frame
      this.$img.addClass('postcard-image-droppable')
    },
    move: function(e) {
      // get bounded mouse position to prevent image from escaping frame
      if (!this.poppedOut) {
        const amountExceeding = this.setBoundedMouseOffset(e.pageX, e.pageY);
        if (amountExceeding > 100) {
          this.popOut()
        }
      } else {
        this.setUnboundedMouseOffset(e.pageX, e.pageY);
      }

      var mover = this;
      if(this._renderId) {
        cancelAnimationFrame(this._renderId);
      }
      this._renderId = requestAnimationFrame(function() { mover.renderMove(); });
    },
    renderMove: function() {
      var left, top;
      left = this.mouseOffset.left + this.mouseToImageOffset.left;
      top = this.mouseOffset.top + this.mouseToImageOffset.top;

      this.$img.offset({left: left, top: top});
    },
    renderFinalPosition: function() {
      var left, top;
      left = this.mouseOffset.left + this.mouseToImage.left;
      top = this.mouseOffset.top + this.mouseToImage.top;
      // bound image to its frame
      var minLeft = this.$cell.width() - this.$img.width(),
        minTop = this.$cell.height() - this.$img.height();
      if(left > 0) left = 0;
      else if(left < minLeft) left = minLeft;
      if(top > 0) top = 0;
      else if(top < minTop) top = minTop;

      this.$img.css('marginLeft', left + 'px');
      this.$img.css('marginTop', top + 'px');
    },
    success: function() {
      this.cleanup();
    },
    cleanup: function() {
      // cancel any pending rendering
      if(this._renderId) {
        cancelAnimationFrame(this._renderId);
      }
      if (!this.poppedOut) {
        // remove the positioning frame
        this.$frame.remove();
      }

      // undo our text selection prevention for IE
      document.onselectstart = null;

      $(window).off('mouseup', this.onMouseUp)
        .off('mousemove', this.onMouseMove);

      // put it back into the cell
      this.$cell.prepend(this.$img.remove());
      this.$img.css({left: '', top: ''});
      this.$img.removeClass('postcard-moving');

      // if it was popped out, swap it if necessary
      if (this.poppedOut) {
        this.$img.removeClass('postcard-image-droppable')
        const {left, top} = this.mouseOffset
        const destCell = _.find(this.postcard.cells, cell => {
          const $cell = $(cell)
          const cellOffset = $cell.offset()
          return left > cellOffset.left &&
                 left < cellOffset.left + $cell.width() &&
                 top > cellOffset.top &&
                 top < cellOffset.top + $cell.height()
        })
        if (destCell && destCell !== this.$cell.get(0)) {
          const $destCell = $(destCell)
          const srcImage = _.extend({}, this.postcard.images[this.$cell.attr('data-imageI')])
          const destImage = _.extend({}, this.postcard.images[$destCell.attr('data-imageI')])
          ;[srcImage, destImage].forEach(image => {
            image.scale = image.marginLeft = image.marginTop = null
            image.img = image.img.cloneNode()
          })
          this.postcard.fillCell($destCell, srcImage, true, false)
          this.postcard.fillCell(this.$cell, destImage, true, false)

          const destScaler = new ImageScaler(this.postcard, $destCell)
          destScaler.$el.hide();
          this.postcard.imageScalers.push(destScaler);

          const scaler = new ImageScaler(this.postcard, this.$cell)
          scaler.$el.hide();
          this.postcard.imageScalers.push(scaler);
        }
      }

      // adjust margins to it's in the place the user positioned it
      this.$img.addClass('notransition');
      this.renderFinalPosition();
      var pc = this;
      _.defer(function() {
        pc.$img.removeClass('notransition');
      });

      this.postcard.imageMoveComplete();
    }
  }


});



// WEBPACK FOOTER //
// ./public/javascripts/postcards/postcard.js